export default __webpack_public_path__ + "static/media/Customer.369ad98f.svg";